import { pipe, prop, propOr, map, flatten, uniq } from "ramda";
import { datesOverlap } from "./dates";

const getWorkplans = pipe(map(propOr([], "workPlans")), flatten);
const mapToRequirements = map(prop("requirements"));
const getImpactWorkloadTasks = pipe(map(prop("impactWorkloadTasks")), flatten);
const getWorkstreams = pipe(map(prop("workstreams")), flatten);
const getIds = map(prop("id"));

const getUniqueIds = pipe(getIds, uniq);
export const getAllWorkstreamIdsFromRosters = pipe(
  getWorkplans,
  mapToRequirements,
  getImpactWorkloadTasks,
  getWorkstreams,
  getUniqueIds
);

const isEmptyArray = (arr) => arr.length === 0;
const arrayContainsValue =
  (arr = []) =>
  (value) =>
    arr.includes(value);
const arrayIsEmptyOrHasElement =
  (arrToCompareTo = []) =>
  (arr) => {
    const containsValue = arrayContainsValue(arrToCompareTo);
    return isEmptyArray(arr) || arr.some(containsValue);
  };

export const getScenariosThatCanBeUsed = ({
  allScenarios,
  rosters,
  startDate,
  endDate,
}) => {
  const overrideDatesOverlap = datesOverlap(startDate, endDate);
  const allWorkstreams = getAllWorkstreamIdsFromRosters(rosters);
  const overrideAffectsWorkstreams = arrayIsEmptyOrHasElement(allWorkstreams);

  return allScenarios.filter((scenario) => {
    return scenario.overrides.some((override) => {
      return (
        overrideDatesOverlap(override.startTime, override.endTime) &&
        overrideAffectsWorkstreams(getUniqueIds(override.workstreams))
      );
    });
  });
};
